export class Announcement {
    id: string
    title: string
    image: string
    status: number
    description: string
    availableAllUser: boolean
    roleIds: []
    validUntil: string
}
